import { MonthPickerInput } from '@mantine/dates';
import './MonthFilter.css';
import { useRef } from 'react';
import { Button, Text } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
export const invoiceMonthValue = (date: Date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}`;
export function InvoiceMonthFilter({value,onChange,label}:{value:string;onChange:(month:string)=>void;label?:string}) {
  const {t}=useTranslation();
  const lastMonth=useRef(invoiceMonthValue(new Date()));
  if(value!=='all')lastMonth.current=value;
  const all=value==='all';
  const shift=(amount:number)=>{const [year,month]=lastMonth.current.split('-').map(Number);onChange(invoiceMonthValue(new Date(year,month-1+amount,1)));};
  return <div className="invoice-kanban-month invoice-month-compact" role="group" aria-label={label || t('invoices.kanban.monthFilter')}>
    {label && <Text className="page-month-date-label" size="xs" color="dimmed" mb={3}>{label}</Text>}
    <div className="invoice-month-control-row">
    <div className="invoice-month-navigation">
      <Button variant="default" size="xs" className="invoice-month-arrow" disabled={all} onClick={()=>shift(-1)} aria-label={t('invoices.kanban.previousMonth')}><IconChevronLeft size={17}/></Button>
      <MonthPickerInput aria-label={label || t('invoices.kanban.monthFilter')} disabled={all}
        value={new Date(Number(lastMonth.current.slice(0,4)),Number(lastMonth.current.slice(5))-1,1)} valueFormat="MMMM YYYY"
        classNames={{input:'app-month-picker-input'}} popoverProps={{withinPortal:true}}
        onChange={date=>{if(date)onChange(invoiceMonthValue(date));}}/>
      <Button variant="default" size="xs" className="invoice-month-arrow" disabled={all} onClick={()=>shift(1)} aria-label={t('invoices.kanban.nextMonth')}><IconChevronRight size={17}/></Button>
    </div>
    <Button variant="subtle" size="xs" className="invoice-current-month" onClick={()=>onChange(invoiceMonthValue(new Date()))}>{t('invoices.kanban.currentMonth')}</Button>
    <Button variant={all?'filled':'subtle'} size="xs" className="invoice-all-months" aria-pressed={all} onClick={()=>onChange('all')}>{t('invoices.kanban.allMonths')}</Button>
    </div>
  </div>;
}
